
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/data-types-casting",
      function () {
        return require("private-next-pages/models/data-types-casting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/data-types-casting"])
      });
    }
  